import React from 'react';
import { Box, Grid, TextField, MenuItem, Button, Alert, FormControlLabel, Checkbox } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus';
import BlockTabQueries from '../../../../../Components/Admin/Pages/Blocks/BlockTabQueries';
import BlockFormTemplateSelect from '../../../../../Components/Admin/Pages/Blocks/BlockFormTemplateSelect';
import { BlockSettingsProps } from './types';

export const DashboardSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
    handleChangeState,
    handleTemplateOptionsChange,
    handleNormalChangeForSettings,
    handleChangeItem,

}) => {
    if (!state.item.defDossier) return <Alert severity="info">{kedo.t('Select an Entity first')}</Alert>;
    return (
        <Box sx={{ mt: 2 }}>
            <Grid container spacing={1} alignItems="flex-end" sx={{ mb: 2 }}>
                <Grid size={{ xs: 11, md: 1, lg: 11 }}>
                    <TextField
                        select
                        size="small"
                        fullWidth
                        label={kedo.t('View name')}
                        name="view_name"
                        value={state.item.settings.view_name || ''}
                        onChange={(e) => handleChangeSettings('view_name', e.target.value)}
                    >
                        <MenuItem value="list">{kedo.t('List')}</MenuItem>
                        {state.views.map((displayView: any) => (
                            <MenuItem key={displayView.id} value={displayView.view_name}>
                                {displayView.view_name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid size={{ xs: 1, md: 1, lg: 1 }}>
                    <Button
                        onClick={() => handleChangeState('showAddView', true)}
                        variant="outlined"
                        size="large"
                    >
                        <FontAwesomeIcon icon={faPlus} />
                    </Button>
                </Grid>
            </Grid>
            <TextField
                size="small"
                fullWidth
                label={kedo.t('Limit')}
                name="limit"
                type="number"
                value={state.item.settings.limit}
                onChange={(e) => handleChangeSettings('limit', Number(e.target.value))}
                margin="normal"
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={state.item.settings.show_add}
                        onChange={(e) => handleChangeSettings('show_add', e.target.checked)}
                    />
                }
                label={kedo.t('Show add buttons')}
                sx={{ mt: 1, mb: 2 }}
            />
            <BlockTabQueries
                kedo={kedo}
                tabQueries={state.item.settings.tabQueries}
                dossierQueries={state.dossierQueries}
                addTabQuery={() => {
                    const newTabQueries = Array.isArray(state.item.settings.tabQueries) ? [...state.item.settings.tabQueries] : [];
                    newTabQueries.push({ query: null, title: '' });
                    handleChangeSettings('tabQueries', newTabQueries);
                }}
                onChangeTabQueries={(item: any, i: number, name: string, value: any) => {
                    const tabQueries = [...state.item.settings.tabQueries];
                    tabQueries[i] = { ...tabQueries[i], [name]: value };
                    handleChangeSettings('tabQueries', tabQueries);
                }}
                deleteTabQuery={(i: number) => {
                    const tabQueries = [...state.item.settings.tabQueries];
                    tabQueries.splice(i, 1);
                    handleChangeSettings('tabQueries', tabQueries);
                }}
            />
            <BlockFormTemplateSelect
                handleTemplateOptionsChange={handleTemplateOptionsChange}

                layout={state.item.settings.layout}

                view_name={state.item.settings.view_name}

                template={state.item.settings.template}

                templateOptions={state.item.settings.templateOptions}

                defDossier={state.item.defDossier}

                handleNormalChange={handleNormalChangeForSettings}

                handleChangeVar={handleChangeItem}

                kedo={kedo}

            />

        </Box>

    );

};